





































import { Component, Vue } from 'vue-property-decorator';
import PostItem from '../models/PostItem';

@Component({
    components: {
    },
})
export default class Research extends Vue {
    private items: PostItem[] = [
        {
            image: '../assets/images/Fantasy.png',
            title: 'Lorem ipsum is Latin, and comes from an ancient text on the theory',
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut lab',
            date: 'March 8, 2:52am',
        }, {
            image: '../assets/images/Fantasy.png',
            title: 'Lorem ipsum is Latin, and comes from an ancient text on the theory',
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut lab',
            date: 'March 8, 2:52am',
        }, {
            image: '../assets/images/Fantasy.png',
            title: 'Lorem ipsum is Latin, and comes from an ancient text on the theory',
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut lab',
            date: 'March 8, 2:52am',
        }, {
            image: '../assets/images/Fantasy.png',
            title: 'Lorem ipsum is Latin, and comes from an ancient text on the theory',
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut lab',
            date: 'March 8, 2:52am',
        },
    ];
}
